import React, { useState, useEffect } from 'react';
import CommonMessage from "../components/CommonMessage";
import { contractCall, web3AccountCheck } from '../helper/web3helper';
import hostContract from '../web3/hostContract.json';
import web3Config from '../web3/web3Config.json';
import Cookies from "universal-cookie";
import { useSelector } from 'react-redux';
import { listDrafts } from '../db/at-rest.js';
import { useWalletReconnectionWithLoader } from '../helper/useWalletReconnection';
import { reportError, toErrorString } from '../utils/errorLogger';
const cookies = new Cookies();


function Draft() {
  const [web3Value, setWeb3] = useState(null);
  const [account, setAccount] = useState('');
  const [web3Contract, setWeb3Contract] = useState('');
  const [allBoxList, setAllBoxList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [rendered, setRendered] = useState(false);
  const [text, setText] = useState("")

  useEffect(() => {
    web3AccountCheck(setWeb3, setAccount);
    if (web3Contract) {
      setEmail();
    }
  }, []);

  useWalletReconnectionWithLoader(
    setLoader,
    setText,
    web3AccountCheck,
    setWeb3,
    setAccount,
    () => setEmail(),
    web3Contract
  );

  useEffect(() => {
    if (account && web3Value) {
      const contractInstance = contractCall(hostContract.contract, web3Config.CONTRACT);
      setWeb3Contract(contractInstance);
    }
  }, [web3Value, account]);

  const getRefreshMessage = useSelector((state) => state.refreshMessage);
  useEffect(() => {
    if (web3Contract || getRefreshMessage) { setEmail(); }
  }, [web3Contract, getRefreshMessage]);


  const reRender = () => { setEmail(); }


  async function setEmail(loaderRequired = true) {

    try {

      if (!web3Contract) return;

      if (loaderRequired) {
        setLoader(true);
        setText("Please wait, data is loading from the blockchain, Going forward it will be fast.")
        setRendered(false);
      }
      // Rows are sealed at rest (db/at-rest.js); listDrafts() decrypts them, newest last as the raw table
      // was, so the existing .reverse() still yields newest-first.
      const indexdb = (await listDrafts()).reverse();
      const reasign = indexdb.map(data => {
        const jsonData = data.json;
        jsonData.id = data.id;
        return jsonData;
      });
      setAllBoxList(reasign);

      if (loaderRequired) {
        setRendered(true);
      }

    } catch (error) {
      const errorStr = toErrorString(error || error.message);
      const userName = localStorage.getItem('UserName');
      reportError({
        endpoint: '-',
        message: `FileName: Draft.js, Fun: setEmail, ${String(error.message || 'Unhandled error')}`,
        error: errorStr,
        userName: userName || '',
      });
      console.log("error", error);
    }
  }

  useEffect(() => {
    if (rendered) {
      setLoader(false)
      setText("")
    }
  }, [rendered]);


  return (
    <div className="inbox-container">
      <CommonMessage messageList={allBoxList} pageType={"Draft"} unreadList={[]} readList={[]} loader={loader} reRender={reRender} id="dmail" text={text} />
    </div>
  );
}

export default Draft;
